import api from '@/api'
/* eslint-disable global-require */

// initial state
const state = {
  isSearch: false,
  mapShow: false,
  scrollTop: 0,
  tabBgChange: false,
  tabItem: {
    en: '',
    cn: ''
  },
  managementMessages: [],
  selectManagementMessage: {},
  teachersDetail: {},
  directions: [],
  directionsImg: [
    {
      img: require('@/assets/images/book.svg'),
    },
    {
      img: require('@/assets/images/technology.svg'),
    },
    {
      img: require('@/assets/images/chip.svg'),
    },
    {
      img: require('@/assets/images/medical.svg'),
    },
    {
      img: require('@/assets/images/car.svg'),
    },
    {
      img: require('@/assets/images/application.svg'),
    }
  ],
  directionsDetail: {},
  bases: [
    {
      title: '国家级省部级基地',
      title_en: 'National provincial and ministerial base',
      img: require('@/assets/images/nationalBase.svg'),
    },
    {
      title: '产学研联合基地',
      title_en: 'Industry-University-Research Joint Base',
      img: require('@/assets/images/cooperation.svg'),
    },
    {
      title: '国际联合研发平台',
      title_en: 'International joint research and development platform',
      img: require('@/assets/images/overseasJoint.svg'),
    }
  ],
  jointBases: [],
  nation: [],
  results: [
    // {
    //   name: '重大成果',
    //   name_en: 'Major Achievements',
    //   img: require('@/assets/images/results.svg'),
    //   type: 'result',
    // },
    {
      name: '科研获奖',
      name_en: 'Research Awards',
      img: require('@/assets/images/award.svg'),
      type: 'award',
    },
    {
      name: '科研成果',
      name_en: 'Research Programs',
      img: require('@/assets/images/project.svg'),
      type: 'project',
    },
    {
      name: '论文专利',
      name_en: 'Papers & Patents',
      img: require('@/assets/images/paper.svg'),
      type: 'paper',
    }
  ],
  result: {},
  resultMessage: {},
  table: [
    {
      name: 'Joint Cuts and Matching of Partitions in One Graph',
      writer: 'Tianshu Yu ; Junchi Yan ; Jieyi Zhao ; Baoxin Li'
    },
    {
      name: 'Joint Cuts and Matching of Partitions in One Graph',
      writer: 'Tianshu Yu ; Junchi Yan ; Jieyi Zhao ; Baoxin Li'
    },
    {
      name: 'Joint Cuts and Matching of Partitions in One Graph',
      writer: 'Tianshu Yu ; Junchi Yan ; Jieyi Zhao ; Baoxin Li'
    },
    {
      name: 'Joint Cuts and Matching of Partitions in One Graph',
      writer: 'Tianshu Yu ; Junchi Yan ; Jieyi Zhao ; Baoxin Li'
    },
    {
      name: 'Joint Cuts and Matching of Partitions in One Graph',
      writer: 'Tianshu Yu ; Junchi Yan ; Jieyi Zhao ; Baoxin Li'
    },
    {
      name: 'Joint Cuts and Matching of Partitions in One Graph',
      writer: 'Tianshu Yu ; Junchi Yan ; Jieyi Zhao ; Baoxin Li'
    },
    {
      name: 'Joint Cuts and Matching of Partitions in One Graph',
      writer: 'Tianshu Yu ; Junchi Yan ; Jieyi Zhao ; Baoxin Li'
    },
    {
      name: 'Joint Cuts and Matching of Partitions in One Graph',
      writer: 'Tianshu Yu ; Junchi Yan ; Jieyi Zhao ; Baoxin Li'
    },
    {
      name: 'Joint Cuts and Matching of Partitions in One Graph',
      writer: 'Tianshu Yu ; Junchi Yan ; Jieyi Zhao ; Baoxin Li'
    },
    {
      name: 'Joint Cuts and Matching of Partitions in One Graph',
      writer: 'Tianshu Yu ; Junchi Yan ; Jieyi Zhao ; Baoxin Li'
    },
    {
      name: 'Joint Cuts and Matching of Partitions in One Graph',
      writer: 'Tianshu Yu ; Junchi Yan ; Jieyi Zhao ; Baoxin Li'
    },
  ],
  banners: [],
  banner: {},
  scienceArticle: [],
  information: [],
  nationalBase: [],
  resultSA: [],
  resultName: '',
  searchSA: [],
  searchWord: '',
  firstPlay: 0,
  secondPage: {
    cn: '',
    en: '',
  },
}

// getters
const getters = {
}

// mutation types
const SETUP_IS_SHEARCH = 'SETUP_IS_SHEARCH'
const SETUP_SCROLL_TOP = 'SETUP_SCROLL_TOP'
const SETUP_TAB_BG = 'SETUP_TAB_BG'
const SETUP_TAB = 'SETUP_TAB'
const SETUP_DIRECTIONS_DETAIL = 'SETUP_DIRECTIONS_DETAIL'
const SETUP_BASE_NUM = 'SETUP_BASE_NUM'
const SETUP_JOINT_SHOW = 'SETUP_JOINT_SHOW'
const SETUP_NATION_SHOW = 'SETUP_NATION_SHOW'
const SETUP_RESULTS_MESSAGES = 'SETUP_RESULTS_MESSAGES'
const SETUP_MAP_SHOW = 'SETUP_MAP_SHOW'
const FIND_BANNERS = 'FIND_BANNERS'
const FIND_BANNER = 'FIND_BANNER'
const FIND_HOME_SA = 'FIND_HOME_SA'
const FIND_HOME_INFORMATION = 'FIND_HOME_INFORMATION'
const FIND_BASES = 'FIND_BASES'
const FIND_SA = 'FIND_SA'
const SETUP_RESULT_NAME = 'SETUP_RESULT_NAME'
const SEARCH_SA = 'SEARCH_SA'
const SETUP_MANAGE_MES = 'SETUP_MANAGE_MES'
const SETUP_FIRST_PLAY = 'SETUP_FIRST_PLAY'
const SETUP_SECOND_PAGE = 'SETUP_SECOND_PAGE'

// actions
const actions = {
  async findBanner({ commit }) {
    const result = await api.home.findBanner()
    commit(FIND_BANNERS, { banners: result })
  },

  async findMessages({ commit }, { id }) {
    const result = await api.home.findMessages(id)
    commit(FIND_BANNER, { banner: result })
  },

  async findHomeScienceArticle({ commit }) {
    const result = await api.home.findHomeScienceArticle()
    commit(FIND_HOME_SA, { scienceArticle: result })
  },

  async findScienceArticle({ commit }, { category }) {
    const result = await api.home.findScienceArticle(category)
    commit(FIND_SA, { category, result: result.scienceArticles })
  },

  async findResearchDirections({ commit }, { category }) {
    const { teacherResearchs } = await api.home.findResearchDirections()
    commit(FIND_SA, { category, result: teacherResearchs })
  },

  async findHomeInformation({ commit }) {
    const result = await api.home.findHomeInformation()
    commit(FIND_HOME_INFORMATION, { information: result })
  },

  async findBase({ commit }, { category }) {
    const result = await api.home.findBase(category)
    commit(FIND_BASES, { category, bases: result.bases })
  },

  async searchScienceArticle({ commit }, { category, word }) {
    const result = await api.home.searchScienceArticle(category, word)
    commit(SEARCH_SA, { result, word, })
  },
}

// mutations
const mutations = {
  [SETUP_FIRST_PLAY](state, { type }) {
    state.firstPlay = type
  },

  [SETUP_SECOND_PAGE](state, { page }) {
    state.secondPage = page
  },

  [SETUP_MANAGE_MES](state, { message }) {
    state.selectManagementMessage = message
  },

  [SEARCH_SA](state, { result, word }) {
    state.searchSA = result
    state.searchWord = word
  },

  [SETUP_RESULT_NAME](state, { name }) {
    state.resultName = name
  },

  [FIND_SA](state, { category, result }) {
    if (category === 'CultivateManage') {
      state.managementMessages = result
      return
    }

    if (category === 'ResearchDirection') {
      state.directions = result
      return
    }

    if (category === 'NationalBase') {
      state.nationalBase = result
      return
    }

    if (category === 'MajorAchievements') {
      state.resultSA = result
      state.resultName = '重大成果'
      return
    }

    if (category === 'ResearchAwards') {
      state.resultSA = result
      state.resultName = '科研获奖'
      return
    }

    if (category === 'ResearchProjects') {
      state.resultSA = result
      state.resultName = '科研成果'
      return
    }

    // if (category === 'Patent') {
    //   state.resultSA = result
    //   state.resultName = '专利'
    //   return
    // }

    state.resultSA = result
    state.resultName = '论文专利'
  },

  [FIND_BASES](state, { category, bases }) {
    if (category !== 'ChanXueYan') {
      const nation = bases.map((base) => {
        base.show = false
        return base
      })
      state.nation = nation
      return
    }

    const jointBases = bases.map((base) => {
      base.show = false
      return base
    })
    state.jointBases = jointBases
  },

  [FIND_HOME_INFORMATION](state, { information }) {
    state.information = information
  },

  [FIND_HOME_SA](state, { scienceArticle }) {
    state.scienceArticle = scienceArticle.scienceArticles
  },

  [FIND_BANNER](state, { banner }) {
    state.banner = banner.article
  },

  [FIND_BANNERS](state, { banners }) {
    state.banners = banners.articles
  },

  [SETUP_RESULTS_MESSAGES](state, { message }) {
    state.resultMessage = message
  },

  [SETUP_JOINT_SHOW](state, { num }) {
    state.jointBases[num].show = !state.jointBases[num].show
  },

  [SETUP_NATION_SHOW](state, { num }) {
    state.nation[num].show = !state.nation[num].show
  },

  [SETUP_BASE_NUM](state, { num }) {
    state.baseNum = num
  },

  [SETUP_DIRECTIONS_DETAIL](state, { detail }) {
    state.directionsDetail = detail
  },

  [SETUP_TAB](state, { tab }) {
    state.tabItem = tab
  },

  [SETUP_IS_SHEARCH](state, { type }) {
    state.isSearch = type
  },

  [SETUP_SCROLL_TOP](state, { top }) {
    state.scrollTop = top
  },

  [SETUP_TAB_BG](state, { type }) {
    state.tabBgChange = type
  },

  [SETUP_MAP_SHOW](state, { type }) {
    state.mapShow = type
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js